/**
 * Created by User on 18/02/2016.
 */
export default AdElementBase;

function AdElementBase(url) {
  var self = this;
  this._url = url;

  this.dispose = function() {};

  this.load = function() {};

  this.track = function() {};

  Object.defineProperties(this, {
    'url': {
      enumerable: true,
      configurable: true,
      get: function () {
        return self._url;
      },
      set: function (url) {
        self._url = url;
      }
    },
    'trackingData': {
      writable: false,
      enumerable: true,
      configurable: true,
      value: null
    },
    'vastData': {
      writable: false,
      enumerable: true,
      configurable: true,
      value: null
    },
    'linear': {
      writable: false,
      enumerable: true,
      configurable: true,
      value: null
    }
  });
}

AdElementBase.prototype.constructor = AdElementBase;

//module.export = AdElementBase;